export const getMilestoneTrackerView = (state) => {
  return state.pages.projectView.modalData.milestoneTracker.view;
};
